import React, { useState } from 'react';
import Header from '../components/Header';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaInstagram } from 'react-icons/fa';
import Footer from '../components/Footer';

function Contact() {

    return (
        <div className="bg-[#e5dedb] min-h-screen">
            <Header />

            <div id="contact" className="p-4 md:p-8 md:pt-[5%] pt-16 min-h-[100vh] flex flex-col justify-center">

                <div className="flex flex-col md:flex-row justify-between w-full  mx-auto">
                    {/* Google Maps Embed Section */}
                    <div className="w-full md:w-1/2 mb-8 md:mb-0 md:pr-4 md:px-[10%]">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.203092656924!2d103.83900077532303!3d1.2866437997095137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19e844213013%3A0x8401786c87fb85a8!2sCES%20Centre!5e0!3m2!1sen!2ssg!4v1693927788891!5m2!1sen!2ssg" width="100%" height="350" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        {/* Your new Google Maps Embed */}
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.220387370003!2d101.76124437497063!3d3.035468346940384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc3520057560c9%3A0x847137dd23cfae83!2sCheras%20Trader%20Square!5e0!3m2!1sen!2ssg!4v1696822117581!5m2!1sen!2ssg" className="mt-4" width="100%" height="350" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    {/* Contact Information Section */}
                    <div className="w-full md:w-1/2 m-auto">
                        <h2 className="text-4xl font-bold text-center mb-8">Contact Information</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-lg mx-auto">

                            {/* Phone Number */}
                            <div className="flex flex-col items-center">
                                <FaPhone size={32} color="#121212" className="mb-2" />
                                <div className="text-center">
                                    <p>(SG) +65 8720 6093</p>
                                    <p>(MY) +60 11 234 48820</p>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="flex flex-col items-center">
                                <FaEnvelope size={32} color="#121212" className="mb-2" />
                                <div className="text-center">
                                    <p>studio<span style={{ fontFamily: 'Arial, sans-serif', fontSize: 11 }}>@</span>schediopartners.com</p>
                                </div>
                            </div>

                            {/* Address */}
                            <div className="flex flex-col items-center">
                                <FaMapMarkerAlt size={32} color="#121212" className="mb-2" />
                                <div className="text-center">
                                    <p>(SG) 171 Chin Swee Road</p>
                                    <p>#04-04 CES Center</p>
                                    <p>Singapore 169877</p>
                                    <p>(MY) Jln Dataran Cheras 4</p>
                                    <p>#72-1-A Cheras Trader Square</p>
                                    <p>Selangor, Malaysia 43200</p>
                                </div>
                            </div>

                            {/* Instagram */}
                            <div className="flex flex-col items-center">
                                <FaInstagram size={32} color="#121212" className="mb-2" />
                                <div className="text-center">
                                    <p>schedio<span style={{ fontFamily: 'Arial, sans-serif', fontSize: 11 }}>_</span>partners</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Contact;
